import { render, staticRenderFns } from "./FormularioChapuzon2025.vue?vue&type=template&id=c67bfaf4&scoped=true&"
import script from "./FormularioChapuzon2025.vue?vue&type=script&lang=ts&"
export * from "./FormularioChapuzon2025.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioChapuzon2025.vue?vue&type=style&index=0&id=c67bfaf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67bfaf4",
  null
  
)

export default component.exports